/* eslint-disable react/prop-types */
import FalconCardHeader from 'components/common/FalconCardHeader';
import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import LeafletMapSideBySide from './LeafletMapSideBySide';
import { useState } from 'react';
import { useMemo } from 'react';

const LandCoverMap = ({ landCoverData, coordinates }) => {
  const options = useMemo(() => {
    return landCoverData.map(item => {
      const year = item.title.match(/\d{4}/)[0];
      return { key: item.key, value: year };
    });
  }, [landCoverData]);

  const [leftSide, setLeftSide] = useState(options[1].key);
  const [rightSide, setRightSide] = useState(options[2].key);

  const fullTitle = landCoverData[0]?.title;
  const titleWithoutYear = fullTitle.replace(/\s\d{4}$/, '');

  const endElement = (
    <Row className="g-0">
      <Col style={{ minWidth: '6rem' }}>
        <Form.Select
          className="ps-2 pe-4 py-0"
          defaultValue={options[1].key}
          name="leftSide"
          onChange={e => setLeftSide(e.target.value)}
        >
          {options.map(item => (
            <option key={item.key} value={item.key}>
              {item.value}
            </option>
          ))}
        </Form.Select>
      </Col>
      <Col className="text-center p-0 d-flex align-align-items-center">
        <span className="m-auto px-3">vs</span>
      </Col>
      <Col style={{ minWidth: '6rem' }}>
        <Form.Select
          className="ps-2 pe-4 py-0"
          defaultValue={options[2].key}
          name="leftSide"
          onChange={e => setRightSide(e.target.value)}
        >
          {options.map(item => (
            <option key={item.key} value={item.key}>
              {item.value}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Row>
  );

  return (
    <Card className="h-100">
      <FalconCardHeader
        title={titleWithoutYear}
        titleTag="h5"
        light={true}
        endEl={endElement}
      />
      <Card.Body className="h-100 p-0" dir="ltr">
        <LeafletMapSideBySide
          data={{
            coordinates: coordinates,
            mapData: landCoverData
          }}
          leftSide={leftSide}
          rightSide={rightSide}
          className="h-100 bg-white"
          style={{ minHeight: '400px' }}
        />
      </Card.Body>
      <Card.Footer className="bg-white py-2 card-footer-style">
        <h5 className="mb-0 infrence-info">{landCoverData[0].info}</h5>
      </Card.Footer>
    </Card>
  );
};

export default LandCoverMap;
